/**
 * Топбар вебинара: закрытие, липкость при скролле, отступ шапки.
 *
 * Разметка — `inc/topbar-webinar-sg.php`, подключается из
 * `header-new.php` под тремя ACF-условиями (`top_bar_is_show`,
 * `front_page_show`, `!is_front_page()`). Живой на 24 страницах
 * из 37 проверенных.
 *
 * 🔴 САМО СКРЫТИЕ бара осталось инлайном в шаблоне и перенесено
 * сюда быть не может. Решение зависит от `localStorage`, серверу он
 * недоступен, а скрыть надо ДО первого кадра. Замер переноса:
 * у вернувшегося посетителя 4–5 кадров с баром высотой 87px —
 * контент подпрыгивал. Бандл идёт `type="module"`, всегда отложен.
 *
 * Поэтому модуль видит бар уже в нужном состоянии и скрытием
 * не занимается — только поведением.
 *
 * ⚠️ Классы `top-bar-webinar--fixed` и `header_with-top-bar` живут
 * в легаси `assets/css/popups.css` (подключён на всех 37 страницах),
 * а НЕ в нашем бандле — правило 54, в `src/scss` их переносить нельзя.
 *
 * ⚠️ Цели аналитики этого же бара (`show-topbar`, `click-topbar`)
 * лежат в `assets/js/script.js:1214` отдельной функцией
 * `initTopBarGoals()`. Это НЕ дубль: инлайн ими не занимался,
 * в шаблоне они закомментированы. Аналитика не переносится — §0.12.
 *
 * ⚠️ Снятие `header_with-top-bar`, когда бара на странице НЕТ, тоже
 * делает `script.js:2259` — вне функций, на верхнем уровне. Наш модуль
 * этот случай не трогает: он выходит, если бара нет.
 */

/** Ключ в localStorage. Имя сохранено прежним — иначе бар вернётся всем. */
const STORAGE_KEY = 'localStorageTopBarWebinarSGNEW';

/** Прокрутка, после которой бар становится липким. */
const FIXED_FROM = 70;

export default function TopBar() {
    const topBar = document.querySelector('.js-top-bar-webinar');

    if (!topBar) {
        return;
    }

    // Бар скрыт инлайном — значит визит повторный. Отступ под него
    // снимаем здесь: в инлайне шапки в дереве ещё нет
    if (topBar.style.display === 'none') {
        dropHeaderOffset();
    }

    const topBarClose = document.querySelector('.js-top-bar-webinar-close');

    topBarClose && topBarClose.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, +new Date());
        topBar.style.display = 'none';
        dropHeaderOffset();
    });

    document.addEventListener('scroll', () => {
        topBar.classList.toggle('top-bar-webinar--fixed', window.scrollY >= FIXED_FROM);
    });
}

/**
 * Снимает с шапки отступ под топбар.
 *
 * ⚠️ В инлайне это стояло в `setTimeout(…, 1000)` — и было не эффектом,
 * а обходом гонки: скрипт печатается ДО `<header>`, поэтому
 * `querySelector('header')` отдавал `null`. Замер подтвердил: класс
 * снимался на 1765 мс, то есть отступ полторы секунды висел лишним.
 *
 * Модуль работает после `DOMContentLoaded`, шапка уже в дереве —
 * задержка не нужна, и срабатывает раньше прежнего.
 */
function dropHeaderOffset() {
    document.querySelector('header')?.classList.remove('header_with-top-bar');
}
